<template>
  <div class="wrapp">
    <div class="row">
      <div class="col-12">
        <h2>Exportação da base de emplacamentos</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-3">
        <h6>Período</h6>
        <b-form-select
          v-model="params.period"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3">
        <h6>Fabricante</h6>
        <b-form-select
          v-model="selected"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3">
        <h6>Estado</h6>
        <b-form-select
          v-model="selected"
          :options="states"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3">
        <h6>Município</h6>
        <b-form-select
          v-model="selected"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-3">
        <h6>Área Operacional</h6>
        <b-form-select
          v-model="selected"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3">
        <h6>Segmento</h6>
        <b-form-select
          v-model="selected"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3">
        <h6>SubSegmento</h6>
        <b-form-select
          v-model="selected"
          :options="options"
          size="sm"
        ></b-form-select>
      </div>
      <div class="col-3 mt-auto">
        <button
          @click="getPlates"
          class="btn btn-outline-primary"
        >Filtrar Dados</button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-6 input-area">
        <i
          class="fas fa-search mt-1 mr-2"
          style="font-size: 21px;cursor: pointer;"
        />
        <b-form-input
          v-model="filter"
          @keyup="searchByFilter"
          id="input-name"
          placeholder="Faça uma busca..."
          size="sm"
        />
      </div>
      <div class="col-6 text-right mt-auto">
        <h6>Total: 3.356 registros</h6>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <b-table
          striped
          hover
          :fields="fields"
          :items="plates"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                type="grow"
                class="align-middle"
              ></b-spinner>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 text-right">
        <button
          @click="download"
          class="btn btn-outline-primary"
        >Fazer Download</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data: () => ({
    userAuth: null,
    selected: '0',
    options: [{ value: '0', text: 'Todos' }],
    filter: null,
    typingTimer: null,
    fields: [
      { key: 'date', label: 'Data' },
      { key: 'chassi', label: 'Chassi' },
      { key: 'plate', label: 'Placa' },
      { key: 'model', label: 'Modelo' },
      { key: 'manufacturer', label: 'Fabricante' },
      { key: 'segment', label: 'Segmento' },
      { key: 'subsegment', label: 'SubSeguimento' },
      { key: 'state', label: 'Estado' },
      { key: 'region', label: 'Município' },
    ],
    plates: [
      {
        date: '02/05/2020',
        chassi: 'Teste',
        plate: 'Teste',
        model: 'Teste',
        manufacturer: 'Teste',
        segment: 'Test',
        subsegment: 'Teste',
        state: 'Teste',
        region: 'Teste',
      },
    ],
    params: {
      period: '0',
    },
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
    this.params.token = this.userAuth.token;
  },

  computed: {
    ...mapFields('plates', ['myPlates', 'states']),
  },

  methods: {
    ...mapActions('plates', ['getPlates', 'download']),

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getPlates, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.getPlates();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
}

.input-area {
  display: flex;
  flex-direction: row;
}
</style>
